import * as React from "react";

const SvgIcon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 18 18"
    >
        <path
            d="M8.517 14.049q-2.107-.11-3.556-1.625T3.512 8.78q0-2.195 1.537-3.731T8.78 3.512q2.13 0 3.644 1.449t1.625 3.556l-1.844-.549q-.285-1.186-1.23-1.942-.943-.758-2.195-.758-1.448 0-2.48 1.032T5.268 8.78q0 1.252.758 2.196a3.46 3.46 0 0 0 1.942 1.229zm1.054 3.468a2 2 0 0 1-.395.044H8.78a8.55 8.55 0 0 1-3.424-.692 8.9 8.9 0 0 1-2.788-1.876 8.9 8.9 0 0 1-1.877-2.788A8.55 8.55 0 0 1 0 8.78q0-1.822.691-3.424a8.9 8.9 0 0 1 1.877-2.788A8.9 8.9 0 0 1 5.356.691 8.55 8.55 0 0 1 8.78 0a8.55 8.55 0 0 1 3.425.691 8.9 8.9 0 0 1 2.788 1.877q1.185 1.186 1.876 2.788a8.55 8.55 0 0 1 .692 3.424v.396q0 .197-.044.395l-1.712-.527V8.78q0-2.94-2.042-4.982-2.04-2.042-4.983-2.042-2.94 0-4.982 2.042T1.756 8.78q0 2.942 2.042 4.983 2.041 2.042 4.982 2.042h.264zm6.695.483-3.754-3.754-1.097 3.315-2.635-8.78 8.781 2.634-3.315 1.097L18 16.266z"
        ></path>
    </svg>
);

export default SvgIcon;
